<template>
	<div class="news">
		<!-- banner -->
		<div class="news_banner">
			<img src="../../assets/home/home_banner.png" >
		</div>
		<!-- 主体 -->
		<div class="news_main">
			<div class="news_left">
				<div class="share_title">
					<span>
						<img src="../../assets/news/news_icon.png" >
					</span>
					<span>新闻公告</span>
				</div>
				<div class="left_nav">
					<div class="left_nav_item" :class="{selectColor:get.mid2 == 2}" @click="get.mid2=2;get.page=1;getdata();">高校党建</div>
					<div class="left_nav_item" :class="{selectColor:get.mid2 == 3}" @click="get.mid2=3;get.page=1;getdata();">思政要闻</div>
					<div class="left_nav_item" :class="{selectColor:get.mid2 == 4}" @click="get.mid2=4;get.page=1;getdata();">通知公告</div>
				</div>
			</div>
			<div class="news_right">
				<div class="share_title">
					思政资讯
				</div>
				<div class="right_list">
					<!-- 此处循环 -->
					<el-skeleton :loading="loading" animated :count="newslist.length">
						<template slot="template">
							<div class="right_item">
								<div class="title"><el-skeleton-item style="height: 40px;" variant="text"/></div>
								<div class="sub_title"><el-skeleton-item variant="text" style="height: 80px;"/></div>
								<div class="subtitme"><el-skeleton-item variant="text"/></div>
							</div>
						</template>
						<template>
							<div class="right_item" v-for="item in newslist" @click="goDetail(10,item.id)">
								<div class="title">{{item.title}}</div>
								<div class="sub_title" v-html="item.content"></div>
								<div class="subtitme">{{item.pubtime}}</div>
							</div>
							<el-empty style="margin: auto;" description="暂无数据" v-if='newslist.length == 0'></el-empty>
						</template>
					</el-skeleton>
					<div class="page_box" v-if="totalPage>1">
					    <navigation 
							:pages="totalPage" 
							:current.sync="get.page" 
							@navpage="msgListView">
						</navigation>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import { news } from '@/axios';
	import navigation from '@/components/page.vue';
	export default{
		data(){
			return{
				get:{
					mid2:2,//2思政要闻 3  思政活动   4  文件精神
					page:1
				},
				totalPage : 0,
				newslist:[],
				loading:true
			}
		},
		components: {
			navigation
		},
		methods:{
			// 获取数据
			getdata(){
				var that = this;
				that.newslist = [];
				news.newMore(that.get).then(res => {
					if(res.code == 200){
						if(res.data.pagedata.length > 0){
							that.newslist = res.data.pagedata
						}
						that.totalPage = res.data.total;
						that.loading = false;
					}
				})
			},
			// 详情
			goDetail(bsid,id){
				var that = this;
				that.$emit("highLight",this.$route.query.index,bsid,id,"")
			},
			// 分页
			msgListView(curPage){
				//根据当前页获取数据
				var that = this;
				this.get.page = curPage;
				that.getdata();
				document.getElementsByClassName("layout").scrollTop = 0;
			}
		},
		mounted() {
			var that = this;
			that.getdata();
		},
		created() {
			var that = this;
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.news{
		width: 100%;
		&_banner{
			width: 100%;
			img{
				width: 100%;
				height: auto;
			}
		}
		&_main{
			width: $indexWidth;
			display: flex;
			justify-content: space-between;
			margin:$indexMargin auto;
			.news_left{
				width: 280px;
				padding-right: 50px;
				box-sizing: border-box;
				.share_title{
					color: #bb0000;
					display: flex;
					align-items: center;
					span:nth-child(1){
						display: block;
						width: 21px;
						margin-right: 10px;
						img{
							width: 100%;
							height: 100%;
						}
					}
				}
				.left_nav{
					font-weight: bold;
					font-family: $indexFontTitle;
					width: 100%;
					color: $indexColor2;
					text-align: center;
					line-height: 60px;
					cursor: pointer;
					font-size: 18px;
					:hover{
						color: #bb0000;
					}
				}
			}
			.news_right{
				margin-left: 20px;
				width: 900px;
				.right_list{
					margin-left: -40px;
					padding-left: 40px;
					box-sizing: border-box;
					width: 100%;
					border-left: 2px solid #EEEEEE;
					.right_item{
						cursor: pointer;
						width: 100%;
						font-family: $indexFontSubTitle;
						padding: 15px 0;
						border-bottom: 2px solid #EEEEEE;
						.title{
							color: $indexColor2;
							font-size: 20px;
							font-family: $indexFontSubTitle1;
							margin-bottom: 8px;
							line-height: 30px;
							overflow: hidden;
							display: -webkit-box;
							word-break: break-all;
							text-overflow: ellipsis; 
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							font-weight: bold;
						}
						.sub_title{
							overflow: hidden;
							display: -webkit-box;
							word-break: break-all;
							text-overflow: ellipsis; 
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							line-height: 25px;
							max-height: 50px;
							font-size: 16px;
							color: #333;
						}
						.subtitme{
							width: 100%;
							font-size: 16px;
							color: #333;
							margin-top: 15px;
						}
					}
					.right_item:hover{
						.title{
							color: #bb0000;
						}
						.sub_title{
							color: #bb0000;
						}
						.subtitme{
							color: #bb0000;
						}
					}
				}
			}
		}
	}
	.selectColor{
		color: #bb0000;
	}
</style>
